/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: general.js
 */

(function ($, scsHeader) {
	'use strict';

	/**
	 * Initialize IE compatibility stuff
	 */
	if (navigator.userAgent.indexOf(' Trident/') > -1) {
		$('html').addClass('msIe');
	}

	scsHeader.positionToolbarFiller = function() {
		var $filler = $('.scs-pageheader').find('.filler'),
			$container = $filler.parent();

		if (!$filler.length) {
			return;
		}

		if (document.fonts) {
			var font = [
				$container.css('font-style'),
				$container.css('font-weight'),
				$container.css('font-size'),
				$container.css('font-family').split(',')[0]
			].join(' ');

			document.fonts
				.load(font)
				.then(updateLeftAndWidth, updateLeftAndWidth);

		} else {
			updateLeftAndWidth();
			setTimeout(updateLeftAndWidth, 1000);
			setTimeout(updateLeftAndWidth, 5000);
		}

		function updateLeftAndWidth() {
			var $branchNav = $container.find('#scs-pageheader-branchnav'),
				$toolsNav = $container.find('#scs-pageheader-toolsnav'),
				$userBox = $container.find('#scs-pageheader-userbox'),
				left = $filler.position().left,
				fillerWidth = $filler.width(),
				toolbarWidth = $filler.parent().width();

			if ($branchNav.length){
				left = $branchNav.position().left + $branchNav.outerWidth(false) - 1;
			}

			fillerWidth = toolbarWidth - left;

			if ($userBox.is(':visible').length) {
				fillerWidth = $userBox.position().left - left;
			}

			if ($toolsNav.length){
				fillerWidth = $toolsNav.position().left - left;
			}

			$filler.css({left: left + 'px', width: fillerWidth + 'px'});
		}
	};

	$(document).ready(function(){
		scsHeader.positionToolbarFiller();
	});

	$(window).on('load', function(){
		scsHeader.positionToolbarFiller();
	});

})(window.scsHeaderJQuery, window.scsHeader = window.scsHeader || {});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/general.js
// module id = 33
// module chunks = 0